import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import retailerReportsPageModule from './components/retailer-reports-page/retailer-reports-page-module';

export default angular.module('retailer-reports-routing', [retailerReportsPageModule.name]).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('retailerReports-view', {
      parent: 'arw',
      url: '/reports',
      template: '<retailer-reports-page></retailer-reports-page>',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Reports')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/retailer-reports-routing-module.js